import React from 'react';
import './index.css';

function Pricing() {
  return (
    <section className="pricing-page">
      <div className="pricing-container">
        <header className="pricing-header">
          <h1 className="pricing-title">
            Simple, <span className="pricing-gradient-text">honest</span> pricing.
          </h1>
          <p className="pricing-subtitle">Three tiers. No tricks. Overage billed at a flat rate.</p>
        </header>

        <div className="pricing-table-wrap">
          <table className="pricing-table">
            <thead>
              <tr>
                <th>Tier</th>
                <th>Response Time</th>
                <th>Monthly</th>
                <th>Hours Included</th>
                <th>Overage</th>
              </tr>
            </thead>
            <tbody>
              {/* Starter */}
              <tr className="tier-row">
                <td>
                  <div className="tier-name">Starter</div>
                  <div className="tier-desc">Occasional help — reports, patches, one-off fixes.</div>
                </td>
                <td>
                  <span className="badge badge-slow">
                    <span className="dot dot-slow"></span> 3–5 days
                  </span>
                </td>
                <td>
                  <div className="price-wrap">
                    <div className="price-main">$800</div>
                    <div className="price-sub">/ month</div>
                  </div>
                </td>
                <td>
                  <div className="hours">5 hrs</div>
                  <div className="hours-sub">included</div>
                </td>
                <td>
                  <div className="price-wrap">
                    <div className="price-main price-sm">$180<span className="price-unit">/hr</span></div>
                  </div>
                </td>
              </tr>

              {/* Growth — highlighted */}
              <tr className="tier-row tier-highlight">
                <td>
                  <div className="tier-name">
                    Growth <span className="popular-tag">Most Popular</span>
                  </div>
                  <div className="tier-desc">Steady cadence — integrations, BPMs, reporting.</div>
                </td>
                <td>
                  <span className="badge badge-mid">
                    <span className="dot dot-mid"></span> 1–2 days
                  </span>
                </td>
                <td>
                  <div className="price-wrap">
                    <div className="price-main">$1,600</div>
                    <div className="price-sub">/ month</div>
                  </div>
                </td>
                <td>
                  <div className="hours">10 hrs</div>
                  <div className="hours-sub">included</div>
                </td>
                <td>
                  <div className="price-wrap">
                    <div className="price-main price-sm">$170<span className="price-unit">/hr</span></div>
                  </div>
                </td>
              </tr>

              {/* Priority */}
              <tr className="tier-row">
                <td>
                  <div className="tier-name">Priority</div>
                  <div className="tier-desc">Dedicated support — complex projects, urgent issues.</div>
                </td>
                <td>
                  <span className="badge badge-fast">
                    <span className="dot dot-fast"></span> Same day
                  </span>
                </td>
                <td>
                  <div className="price-wrap">
                    <div className="price-main">$2,800</div>
                    <div className="price-sub">/ month</div>
                  </div>
                </td>
                <td>
                  <div className="hours">20 hrs</div>
                  <div className="hours-sub">included</div>
                </td>
                <td>
                  <div className="price-wrap">
                    <div className="price-main price-sm">$160<span className="price-unit">/hr</span></div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Ad-hoc rate */}
        <div className="adhoc-bar">
          <div>
            <div className="adhoc-label">Need occasional help?</div>
            <div className="adhoc-desc">No retainer needed. Great for one-time projects or exploratory work.</div>
          </div>
          <div className="adhoc-rate">$200 <span className="adhoc-rate-unit">/ hr &nbsp;ad-hoc</span></div>
        </div>

        {/* CTA */}
        <div className="pricing-cta">
          <a href="/contact" className="pricing-cta-btn">Get Started</a>
          <div className="pricing-cta-note">Not sure which tier fits? Let's talk — no commitment required.</div>
        </div>
      </div>
    </section>
  );
}

export default Pricing;
